var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.08333 22.9167H5.10208L18.95 9.06875L16.9312 7.05L3.08333 20.8979V22.9167ZM0.25 25.75V19.7292L18.95 1.06458C19.2333 0.804861 19.5462 0.604167 19.8885 0.4625C20.2309 0.320833 20.591 0.25 20.9688 0.25C21.3465 0.25 21.7125 0.320833 22.0667 0.4625C22.4208 0.604167 22.7278 0.816667 22.9875 1.1L24.9354 3.08333C25.2188 3.34306 25.4253 3.65 25.5552 4.00417C25.6851 4.35833 25.75 4.7125 25.75 5.06667C25.75 5.44444 25.6851 5.80451 25.5552 6.14687C25.4253 6.48924 25.2188 6.80208 24.9354 7.08542L6.27083 25.75H0.25ZM17.9229 8.07708L16.9312 7.05L18.95 9.06875L17.9229 8.07708Z",
    fill: "#2280FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.44d54a4767407d0c9b0f7d442feb85c9.svg";
export { ForwardRef as ReactComponent };